module.exports = "<div data-component=\"summary\" class=\"step\" *ngIf=\"active\">\n\n\t<app-warning [message]=\"changeDigitalSignatureData.message\" [type]=\"changeDigitalSignatureData.success ? 'success' : 'error'\"></app-warning>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-digital-signature/summary/summary.component.html
// module id = ../../../../../src/app/master/change-digital-signature/summary/summary.component.html
// module chunks = main